import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

const BASE = `${config.apis.api.url}/artist-ai/profile`;

const ArtistAiProfileService = {
  getInfoContent() {
    return fetchWrapper.get(`${config.apis.api.url}/ai/artist-setup/info-content`, {
      injectToken: true,
    });
  },

  getProfile(galleryArtistId = null) {
    const query = galleryArtistId
      ? `?gallery_artist_id=${encodeURIComponent(galleryArtistId)}`
      : '';
    return fetchWrapper.get(`${BASE}${query}`, {
      injectToken: true,
    });
  },

  upsertProfile(payload, galleryArtistId = null) {
    const query = galleryArtistId
      ? `?gallery_artist_id=${encodeURIComponent(galleryArtistId)}`
      : '';
    return fetchWrapper.put(`${BASE}${query}`, {
      injectToken: true,
      body: payload,
    });
  },
};

export default ArtistAiProfileService;
